import React from 'react';
import PropTypes from 'prop-types';

import { DataBlocks } from 'components';

import Field from './Field';
import FillStatus from './FillStatus';

const FormGroup = ({
  title,
  description,
  fields,
  onChange,
  fieldIdPrefix,
  fillProgress: {
    progress,
    total,
  },
  ctn,
  apiDateFormat = 'YYYY-MM-DD',
}) => (
  <DataBlocks.ContentGroup
    title={title}
    description={<span dangerouslySetInnerHTML={{ __html: description }} />}
    info={
      <FillStatus progress={progress} total={total} />
    }
  >
    {fields && fields.map((field) => (
      <Field
        {...field}
        key={`user-form-field-${field.id}`}
        ctn={ctn}
        fieldId={fieldIdPrefix
          ? `${fieldIdPrefix}-${field.id}`
          : undefined}
        apiDateFormat={apiDateFormat}
        onChange={({ value, error }) => onChange({
          value,
          error,
          fieldId: field.id,
        })}
      />
    ))}
  </DataBlocks.ContentGroup>
);

FormGroup.propTypes = {
  title: PropTypes.string,
  fieldIdPrefix: PropTypes.string,
  description: PropTypes.string,
  ctn: PropTypes.string,
  apiDateFormat: PropTypes.string,

  fields: PropTypes.array,

  onChange: PropTypes.func,

  fillProgress: PropTypes.object,
};

export default FormGroup;
